import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {LinkSchema} from './link'
import {LinkGroupSchema} from './linkGroup'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentSubnavSchema = buildEntrySchemaFor('primerComponentSubnav', {
  fields: z.lazy(() =>
    z.object({
      cta: safeOptional(LinkSchema),
      heading: LinkSchema,
      subheading: safeOptional(LinkSchema),
      links: z.array(LinkSchema.or(LinkGroupSchema)),
    }),
  ),
})

export type PrimerComponentSubnav = z.infer<typeof PrimerComponentSubnavSchema>
